import { FC, useContext } from "react";
import SimpleCard from "../common/simple-card";
import FlexBox from "../common/flex-box";
import { getTimeInAMPM } from "lib/utils/date-utils";
import SimpleButton from "../common/simple-button";
import { GBP_SYMBOL } from "lib/constants";
import { AppContext } from "lib/contexts/app-context";

interface BookingDetailsTileProps {
  bookingDetails: AppointmentBookingDetails;
  cancelAppointmentTitle?: string;
  onCancelAppointment?: (bookingId: string) => void;
  onCompleteAppointment?: (bookingId: string, status?: string) => void;
  onEditAppointment?: (bookingId: string) => void;
  onUpdateAppointment?: (bookingId: string) => void;
  mode?: "create" | "edit";
}

const BookingDetailsTile: FC<BookingDetailsTileProps> = ({
  bookingDetails,
  cancelAppointmentTitle = "Cancel Appointment",
  onCancelAppointment,
  onCompleteAppointment,
  onEditAppointment,
  mode = "create",
}) => {
  const { appState } = useContext(AppContext);
  const userRole = appState?.userRole;
  return (
    <SimpleCard>
      <FlexBox direction="column" className="gap-2">
        <FlexBox justifyContent="start" alignItems="center">
          <strong>Booked for:</strong>
          <span>{bookingDetails?.therapyName}</span>
        </FlexBox>
        <FlexBox justifyContent="start" alignItems="center">
          <strong>Booked by:</strong>
          <span>
            {bookingDetails?.patientName ?? bookingDetails?.practitionerName}
          </span>
        </FlexBox>
        <FlexBox justifyContent="start" alignItems="center">
          <strong>Attended by:</strong>
          <span>{bookingDetails?.practitionerName}</span>
        </FlexBox>
        <FlexBox justifyContent="start" alignItems="center">
          <strong>Clinic:</strong>
          <span>{bookingDetails?.clinicName}</span>
        </FlexBox>
        <FlexBox justifyContent="start" alignItems="center">
          <strong>Status:</strong>
          <span>{bookingDetails?.status}</span>
        </FlexBox>
        <FlexBox justifyContent="start" alignItems="center">
          <strong>Starting at:</strong>
          <span>{getTimeInAMPM(new Date(bookingDetails?.fromTime))}</span>
        </FlexBox>
        <FlexBox justifyContent="start" alignItems="center">
          <strong>Duration:</strong>
          <span>{bookingDetails?.duration} minutes</span>
        </FlexBox>
        <FlexBox justifyContent="start" alignItems="center">
          <strong>Cost:</strong>
          <span>
            {GBP_SYMBOL}&nbsp;{bookingDetails?.totalCost}
          </span>
        </FlexBox>
        <hr />
        {(mode === 'edit') && (
          <FlexBox justifyContent="center"> 
            <SimpleButton onClick={() => onCancelAppointment?.(bookingDetails?.id)}>
              Update Appointment
            </SimpleButton>
          </FlexBox>
        )}
        {mode !== "edit" && (
        <>
        <FlexBox gap="2">
          {(bookingDetails?.status !== 'completed') && (
            <SimpleButton onClick={() => onCancelAppointment?.(bookingDetails?.id)}>
              {cancelAppointmentTitle}
            </SimpleButton>
          )}
          {/* Status and role-based action buttons */}
          {((userRole === 'practitioner' || userRole === 'admin') && bookingDetails?.status === 'pending') && (
            <SimpleButton variant="success" onClick={() => onCompleteAppointment?.(bookingDetails?.id, 'scheduled')}>
              Mark as Paid
            </SimpleButton>
          )}
          {((userRole === 'practitioner' || userRole === 'admin') &&   bookingDetails?.status === 'scheduled') && (
            <SimpleButton variant="success" onClick={() => onCompleteAppointment?.(bookingDetails?.id, 'completed')}>
              Complete Appointment
            </SimpleButton>
          )}
        </FlexBox>
        {((userRole === 'admin') && bookingDetails?.status !== 'completed') && (
          <>
          <hr/>
          <FlexBox justifyContent="center"> 
            <SimpleButton onClick={() => onEditAppointment?.(bookingDetails?.id)}>
              Edit Appointment
            </SimpleButton>
          </FlexBox>
          </>
        )}
        </>
        )}
      </FlexBox>
    </SimpleCard>
  );
};

export default BookingDetailsTile;
